import { NgClass } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { SyncType } from '@era/locations-sdk';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'era-device-sync-status-retry-ui',
  templateUrl: './device-sync-status-retry.component.html',
  imports: [NgClass, FaIconComponent],
})
export class DeviceSyncStatusRetryComponent {
  readonly syncType = input.required<SyncType>();
  readonly allowRetry = input(false);

  public readonly scheduleTaskEvent = output<SyncType>();

  public retrySync() {
    this.scheduleTaskEvent.emit(this.syncType());
  }
}
